// @ts-nocheck
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import OrderHeader from "@store/Library/Components/Toolkit/Order/OrderHeader";
import constants from "@store/constants";
import { useCurrentPage } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import React, { FC } from "react";
import { useSelector } from "react-redux";

export interface TECSubmitNewHeaderProps extends WidgetProps {}

export interface TECSubmitNewHeaderStyles {}

export const tecSubmitNewHeaderStyles: TECSubmitNewHeaderStyles = {};

const styles = tecSubmitNewHeaderStyles;

const TECSubmitNewHeader: FC<TECSubmitNewHeaderProps> = ({ id }) => {
    const queryParams = parseQueryString<{ returnPage?: string }>(
        useSelector((state: ApplicationState) => getLocation(state).search),
    );

    const currentPage = useCurrentPage();
    const linkBack = queryParams.returnPage
        ? usePageLinkByPageType(queryParams.returnPage)
        : usePageLinkByPageType(constants.pageType.taxExemptionCertificates);

    return (
        <OrderHeader title={currentPage.fields.title} linkBack={linkBack}>
            <Zone contentId={id} zoneName="ActionButtons" />
        </OrderHeader>
    );
};

const widgetModule: WidgetModule = {
    component: TECSubmitNewHeader,
    definition: {
        displayName: "TEC Submit NewHeader",
        group: constants.widgetGroup.tecSubmitNew,
        allowedContexts: ["TECSubmitNewPage" as any],
    },
};

export default widgetModule;
